module.exports = __webpack_public_path__ + "SC04.8ecd7273.json";